import { useEffect, useState } from "react";
import Image from "next/image";
import awsconfig from "../aws-exports";
import { getAuthHeader } from "../lib/getAuthHeader";

const S3Image = ({ imageKey, ...props }) => {
  const [signedUrl, setSignedUrl] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const getSignedUrl = async () => {
      if (!imageKey) {
        setSignedUrl("");
        return;
      }

      setIsLoading(true);
      setError(null);

      try {
        const authHeader = await getAuthHeader();
        const response = await fetch('/api/s3/get-signed-url', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            ...authHeader,
          },
          body: JSON.stringify({
            imageKey: `public/${imageKey}`,
            bucket: awsconfig["aws_user_files_s3_bucket"],
          }),
        });

        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.message || "Failed to get image URL");
        }

        const data = await response.json();
        if (data.success && data.signedUrl) {
          setSignedUrl(data.signedUrl);
        } else {
          throw new Error("Invalid response from server");
        }
      } catch (err) {
        console.error("Error fetching signed URL:", err);
        setError(err.message);
        setSignedUrl(""); // Reset on error
      } finally {
        setIsLoading(false);
      }
    };

    getSignedUrl();

    return () => {
      setSignedUrl("");
    };
  }, [imageKey]);

  // You could add a loading state or error handling here
  if (isLoading) {
    return <div className="image-placeholder">Loading...</div>;
  }

  if (error) {
    console.error("Error loading image:", error);
    // Fall back to default image on error
  }

  return (
    <Image
      src={signedUrl || "/user.svg"}
      {...props}
      alt="s3 image"
    />
  );
};

export default S3Image;

// import { useEffect, useState } from "react";

// import Image from "next/image";
// import awsconfig from "../aws-exports"
// import { useAuth } from "../src/context/auth";

// const S3Image = ({ imageKey, ...props }) => {
//   const { cognitoS3ServiceProvider } = useAuth();
//   const [signedUrl, setSignedUrl] = useState("");
//   useEffect(() => {
//     if (!!imageKey && cognitoS3ServiceProvider) {
//       var params = { Bucket: awsconfig["aws_user_files_s3_bucket"], Key: `public/${imageKey}` };
//       var url = cognitoS3ServiceProvider.getSignedUrl('getObject', params);
//       setSignedUrl(url)
//     }
//     return () => {
//       setSignedUrl("")
//     }
    
//   }, [cognitoS3ServiceProvider, imageKey]);
//   return (
//     <Image
//       src={signedUrl || "/user.svg"}
//       {...props}
//       alt="s3 image"
//     />
//   );
// };

// export default S3Image;
